module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/cards-style6/cards-style6.component.scss
// module id = ./src/app/features/cards/cards-style6/cards-style6.component.scss
// module chunks = main